/**
 * @generated SignedSource<<7b66f4657e5b17dff25c6074e00b86ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequestShippingQuoteBody_viewer$data = {
  readonly buyerItemConversation?: {
    readonly id: string;
    readonly serviceId: string | null;
  } | null;
  readonly conversation?: {
    readonly originalBuyer: {
      readonly user: {
        readonly " $fragmentSpreads": FragmentRefs<"RequestShippingQuoteForm_user">;
      } | null;
    } | null;
    readonly transaction: {
      readonly hasCompletedCheckout: boolean | null;
      readonly id: string;
      readonly isCanceled: boolean | null;
      readonly serviceId: string | null;
    } | null;
  } | null;
  readonly itemRead?: ReadonlyArray<{
    readonly hasPreQuotedShipping?: boolean | null;
    readonly isListingUnlisted?: boolean | null;
    readonly isSold?: boolean | null;
    readonly itemIsOnHold?: boolean | null;
    readonly seller?: {
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"RequestShippingSuccessContent_seller">;
    } | null;
    readonly title?: string | null;
  } | null> | null;
  readonly relevantShipping: {
    readonly quoteRequestStatus: string | null;
    readonly shipmentQuote: {
      readonly isCustom: boolean | null;
      readonly subTotalAmount: {
        readonly amount: number | null;
      } | null;
    } | null;
  } | null;
  readonly transactions?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly hasCompletedCheckout: boolean | null;
        readonly id: string;
        readonly isCanceled: boolean | null;
        readonly lastShipmentQuote: {
          readonly status: string | null;
        } | null;
        readonly serviceId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly user?: {
    readonly id: string;
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"RequestShippingQuoteForm_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"RequestShippingQuoteForm_viewer" | "ShippingDetailsContainer_viewer">;
  readonly " $fragmentType": "RequestShippingQuoteBody_viewer";
};
export type RequestShippingQuoteBody_viewer$key = {
  readonly " $data"?: RequestShippingQuoteBody_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestShippingQuoteBody_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "RequestShippingQuoteForm_user"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v4 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanceled",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasCompletedCheckout",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "conversationId"
    },
    {
      "kind": "RootArgument",
      "name": "hasConversationId"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds"
    },
    {
      "kind": "RootArgument",
      "name": "itemQuantity"
    },
    {
      "kind": "RootArgument",
      "name": "shouldFetchConversation"
    },
    {
      "kind": "RootArgument",
      "name": "shouldFetchItem"
    },
    {
      "kind": "RootArgument",
      "name": "shouldFetchTransaction"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "userIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestShippingQuoteBody_viewer",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isVerifiedTrade",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "shouldFetchItem",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "itemIds.0",
                  "variableName": "itemId"
                }
              ],
              "kind": "ListValue",
              "name": "itemIds"
            }
          ],
          "concreteType": null,
          "kind": "LinkedField",
          "name": "itemRead",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isSold",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isListingUnlisted",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Seller",
                  "kind": "LinkedField",
                  "name": "seller",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "RequestShippingSuccessContent_seller"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreQuotedShipping",
                  "storageKey": null
                },
                {
                  "alias": "itemIsOnHold",
                  "args": [
                    (v3/*: any*/)
                  ],
                  "kind": "ScalarField",
                  "name": "isOnHold",
                  "storageKey": null
                }
              ],
              "type": "Item",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "shouldFetchConversation",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "concreteType": "Conversation",
          "kind": "LinkedField",
          "name": "buyerItemConversation",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "shouldFetchTransaction",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemIds"
            },
            {
              "kind": "Literal",
              "name": "sort",
              "value": "createdDate desc"
            },
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "mc.conversationTransaction"
            }
          ],
          "concreteType": "TransactionConnection",
          "kind": "LinkedField",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TransactionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Transaction",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v2/*: any*/),
                    (v5/*: any*/),
                    (v6/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ShipmentQuote",
                      "kind": "LinkedField",
                      "name": "lastShipmentQuote",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "status",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "hasConversationId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "conversationId",
              "variableName": "conversationId"
            }
          ],
          "concreteType": "Conversation",
          "kind": "LinkedField",
          "name": "conversation",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Transaction",
              "kind": "LinkedField",
              "name": "transaction",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v2/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ConversationMember",
              "kind": "LinkedField",
              "name": "originalBuyer",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": [
        (v3/*: any*/),
        (v4/*: any*/),
        {
          "kind": "Variable",
          "name": "quantity",
          "variableName": "itemQuantity"
        }
      ],
      "concreteType": "RelevantShippingInfo",
      "kind": "LinkedField",
      "name": "relevantShipping",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quoteRequestStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ShipmentQuote",
          "kind": "LinkedField",
          "name": "shipmentQuote",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "subTotalAmount",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "amount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isCustom",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShippingDetailsContainer_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestShippingQuoteForm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "49b39f5bfa8a117e93ab5dc7bcdc76d3";

export default node;
